import axios from 'axios'

export default {
    getDocumentation() {
        return axios.get('/api/technicaldocumentation');
    },
    getFolders() {
        return axios.get('/api/technicaldocumentation/folders');
    },
    createFolder(form) {
        return axios.post('/api/technicaldocumentation/folders', form);
    },
    deleteFolder(id) {
        return axios.delete(`/api/technicaldocumentation/folders/${id}`, id);
    },
    deleteDocument(id) {
        return axios.delete(`/api/technicaldocumentation/${id}`, id);
    },
    uploadDocuments(form) {
        var fd = new FormData();
        for (let prop in form) {
            if (form.hasOwnProperty(prop)) {
                if (prop === 'documents') {
                    for (let i = 0; i < form.documents.length; i++) {
                        if (form.documents[i] instanceof File) {
                            fd.append(`documents`, form.documents[i]);
                        }
                    }
                } else {
                    fd.append(prop, form[prop]);
                }
            }
        }

        return axios.post('/api/technicaldocumentation', fd,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/technicaldocumentation/api.js